import dayjs from 'dayjs';
import { CouponIssueRecord } from '@/types/coupon';

/**
 * 当前文件主要用于处理现金券的通用逻辑
 */

export type CouponItem = CouponIssueRecord & {
  disabled?: boolean; // 是否可用
  name?: string; // 优惠券名称
  subname?: string; // 优惠券描述
};

/**
 * 判断优惠券是否过期
 * @param validityEnd 优惠券过期时间
 * @param nowTime 当前时间
 * @returns 是否过期
 */
export function isExpired(validityEnd: string, nowTime: string): boolean {
  const now = dayjs(nowTime);
  const expireTime = dayjs(validityEnd);
  return now.isAfter(expireTime);
}

/**
 * 检查价格是否满足优惠券门槛
 * @param price 商品价格(单位：分)
 * @param threshold 优惠券门槛价格(单位：分)
 * @returns 是否满足门槛
 */
export function checkThreshold(price: number, threshold: number): boolean {
  // threshold === 0 表示无门槛券，直接返回 true
  if (threshold === 0) {
    return true;
  }
  // 满减券：判断价格是否满足门槛
  return price >= threshold;
}

/**
 * 生成优惠券描述文本
 * @param coupon 优惠券
 * @returns 描述文本
 */
export function generateCouponSubname(coupon: CouponIssueRecord): string {
  if (coupon.threshold_price > 0) {
    return `满${coupon.threshold_price / 100}元减${coupon.discount_price / 100}元`;
  }
  return `无门槛减${coupon.discount_price / 100}元`;
}

/**
 * 计算使用优惠券后的最终价格
 * @param salePrice 销售价(单位：分)
 * @param coupon 当前选择的优惠券
 * @returns 最终价格(单位：分)
 */
export function getFinalPrice(salePrice: number, coupon: CouponItem | null | undefined): number {
  // 如果优惠券为空或为"不使用"选项，则返回原价
  if (!coupon?.id) {
    return salePrice;
  }

  const finalPrice = salePrice - coupon.discount_price;
  return finalPrice > 0 ? finalPrice : 0;
}
